import {createRouter, createWebHistory} from 'vue-router'
import ChoseCollege from '../views/ChoseCollege'

const routes = [
    {
        path: '/',
        name: 'Admin',
        redirect: '/login',
        component: ChoseCollege,
        meta: {
            title: '选志愿'
        },
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue'),
        meta: {
            title: '注册账户'
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
        meta: {
            title: '登录代理商系统后台'
        },
    },
    {
        path: '/chose_college',
        name: 'ChoseCollege',
        component: ChoseCollege,
        meta: {
            title: '选志愿'
        },
    },
    {
        path: '/chose_school',
        name: 'ChoseSchool',
        component: () => import(/* webpackChunkName: "about" */ '../views/ChoseSchool.vue'),
        meta: {
            title: '选志愿-院校专业'
        },
    },
    {
        path: '/favorite_list',
        name: 'FavoriteList',
        component: () => import(/* webpackChunkName: "about" */ '../views/FavoriteList.vue'),
        meta: {
            title: '收藏列表'
        },
    },
    {
        path: '/home_page',
        name: 'HomePage',
        component: () => import(/* webpackChunkName: "about" */ '../views/HomePage.vue'),
        meta: {
            title: '代理商'
        },
    },
    {
        path: '/goods',
        name: 'Goods',
        component: () => import(/* webpackChunkName: "about" */ '../views/Goods.vue'),
        meta: {
            title: '商品列表'
        },
    },
    {
        path: '/approval',
        name: 'Approval',
        component: () => import(/* webpackChunkName: "about" */ '../views/Approval.vue'),
        meta: {
            title: '审核志愿'
        },
    },
    {
        path: '/index',
        name: 'Index',
        component: () => import(/* webpackChunkName: "about" */ '../views/Index.vue'),
        meta: {
            title: '首页'
        },
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
